module.exports = {
    INVOICES:'/invoices',
    CREATE_INVOICE:'/invoices/create-invoice',
    REQUESTING_INVOICE:'/invoices/requesting-invoice',

    //infulancer
    INFULANCER_LINK_LIST:'/infulancer/infulancer-link-list',
    // REQUERSTING_INVOICE_AFFILIATE:'/invoices/affiliate-orders'
}